export enum TabName {
  PRICE_HISTORY = 'price-history',
  CYLINDER_PRICING = 'cylinder-pricing',
  CLIENTS = 'clients',
  COLABORATORS = 'colaborators',
  SURVEYS = 'surveys',
  STAR_CLIENT = 'start-client',
}
